<template>
  <section id="section-product" class="section">
    <div class="flex-column section-content d-flex">
      <div class="section-title-container d-flex">
        <a style="align-self: center">我们的产品</a>
      </div>
      <div class="d-flex flex-column flex-lg-row section-container">
        <div class="d-none d-lg-flex" style="flex: 0.5">
          <div class="flex-column" style="align-self: center;margin: auto">
            <div><img class="brand-logo" src="../assets/logo_large.png"/></div>
            <div class="brand-name" style="margin-top: 20px;text-align: center">建个会</div>
            <div class="subtitle" style="margin-top: 8px">安全做会就用建个会</div>
          </div>
        </div>
        <swiper class="swiper-container" :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(tab, index) in tabs" :key="index">
            <div><img :src="tab.img"/></div>
          </swiper-slide>
        </swiper>
      </div>
      <nav class="nav justify-content-space">
        <div class="d-flex swiper-indicator" v-for="(tab, index) in tabs" :key="index">
          <div v-bind:id="'indicator-'+index" v-if="index!==selelected" class="card indicator-normal"
               v-on:click="switchSwiper(index+1)">
            <div class="d-flex"><img :src="tab.icon" style="margin: auto"/></div>
            <div class="subtitle">{{tab.title}}</div>
          </div>
          <div v-else v-bind:id="'indicator-'+index" class="card indicator-selected">
            <div class="d-flex"><img :src="tab.icon_s" style="margin: auto"/></div>
            <div class="subtitle" style="color: #f4f4f4">{{tab.title}}</div>
          </div>
          <div class="d-none d-lg-flex">
            <img style="margin: auto" v-if="tabs.length-index-1" src="../assets/img_intro_split.png"/>
          </div>
        </div>
      </nav>
    </div>
  </section>
</template>

<script>
  // require styles
  import 'swiper/dist/css/swiper.css'
  import {swiper, swiperSlide} from 'vue-awesome-swiper'

  export default {
    name: "SectionProduct",
    components: {swiper, swiperSlide},

    methods: {
      switchSwiper(idx) {
        this.selelected = idx - 1;
        this.swiper.slideTo(idx, 500);
      }
    },

    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },

    data() {
      let that = this;
      return {
        swiperOption: {
          spaceBetween: 30,
          loop: true,
          effect: 'cube',
          grabCursor: true,
          cubeEffect: {shadow: false, slideShadows: false},
          on: {
            slideChangeTransitionStart: function () {
              if (this.activeIndex > that.tabs.length) {
                that.selelected = 0
              } else if (this.activeIndex <= 0) {
                that.selelected = that.tabs.length - 1;
              } else {
                that.selelected = this.activeIndex - 1;
              }
            },
          },
        },
        selelected: 0,
        tabs: [
          {
            img: require("../assets/img_intro_create.png"),
            icon: require("../assets/icon_intro_create.png"),
            icon_s: require("../assets/icon_intro_create_white.png"),
            title: "在线建会"
          },
          {
            img: require("../assets/img_intro_invite.png"),
            icon: require("../assets/icon_intro_invite.png"),
            icon_s: require("../assets/icon_intro_invite_white.png"),
            title: "邀亲友入会"
          },
          {
            img: require("../assets/img_intro_bid.png"),
            icon: require("../assets/icon_intro_bid.png"),
            icon_s: require("../assets/icon_intro_bid_white.png"),
            title: "在线投标"
          },
          {
            img: require("../assets/img_intro_wx.png"),
            icon: require("../assets/icon_intro_wx.png"),
            icon_s: require("../assets/icon_intro_wx_white.png"),
            title: "微信记账"
          },
          {
            img: require("../assets/img_intro_eiou.png"),
            icon: require("../assets/icon_intro_eiou.png"),
            icon_s: require("../assets/icon_intro_eiou_white.png"),
            title: "打电子借条"
          }
        ],
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~bootstrap/scss/bootstrap";

  .swiper-indicator {
    width: 20%;
    text-align: center;
  }

  @media (min-width: 992px) {
    .swiper-container {
      width: 610px;
      height: 610px;
      flex: 0.5
    }

    .swiper-indicator .card {
      border: none;
      align-self: center;
      width: 100%;
      margin: 20px;
    }

    .swiper-indicator .card > div > img {
      margin: auto;
    }

    .subtitle {
      font-size: 18px;
      color: #878787;
    }

    .section-container {
      margin-top: 52px;
    }

    .brand-name {
      font-size: 30px;
      font-family: "PingFang SC", serif;
      font-weight: bold;
      color: #333;
    }

    .brand-logo {
      width: 96px;
      height: 96px;
      border-radius: 5px;
    }
  }

  @media (max-width: 992px) {
    .swiper-container {
      margin: 10px auto;
    }

    .swiper-indicator .card {
      border: none;
      margin: auto;
      width: 100%;
      max-width: 120px;
    }

    .swiper-indicator .card > div > img {
      margin: auto;
      max-width: 48px;
      max-height: 48px;
    }

    .subtitle {
      font-size: 10px;
      color: #878787;
      margin: 0 2px 0;
    }

    .swiper-container {
      width: 100%;
      height: 100%;
    }

    .brand-name {
      font-size: 18px;
      font-family: "PingFang SC", serif;
      font-weight: bold;
      color: #333;
    }

    .nav {
      margin: 0 20px;
    }
  }

  .indicator-normal {
    cursor: pointer;
  }

  .indicator-normal:hover {
    background-color: #f4f4f4;
  }

  .indicator-selected {
    background-color: #3773e0;
  }
</style>



// WEBPACK FOOTER //
// src/components/SectionProduct.vue